module.exports = __webpack_public_path__ + "img/vacation-list-banner.3c19dd3.png";